<template>
  <el-radio-group
    @change="change"
    v-model="radioValue"
    :class="inline && 'inline'"
  >
    <slot></slot>
  </el-radio-group>
</template>

<script>
export default {
  name: 'RadioGroup',

  props: {
    value: {
      required: false
    },

    inline: {
      type: Boolean,
      default: false
    },
    change: {
      type: Function,
      required: false,
      default: () => {}
    }
  },

  computed: {
    radioValue: {
      get() {
        return this.value
      },

      set(radioValue) {
        this.$emit('input', radioValue)
      }
    }
  }
}
</script>

<style scoped>
.el-radio-group {
  width: 100%;
}

.el-radio-group.inline {
  display: flex;
}

>>> .el-radio {
  width: 100%;
  margin: 0 0 8px 0 !important;
}

>>> .el-radio:last-child {
  margin: 0 !important;
}

.el-radio-group.inline >>> .el-radio {
  margin: 0 8px 0 0 !important;
}

.el-radio-group.inline >>> .el-radio:last-child {
  margin: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/common/components/form/RadioGroup.vue